import {
  Button,
  Form,
  Input,
  Layout,
  Menu,
  MenuProps,
  message,
  Modal,
} from "antd";
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/es/layout/layout";
// import "./Wrapper.css";
import {
  AlertFilled,
  CalculatorOutlined,
  CalendarFilled,
  CheckCircleFilled,
  CheckSquareOutlined,
  ClockCircleFilled,
  ClockCircleOutlined,
  ExclamationCircleFilled,
  FieldTimeOutlined,
  LineChartOutlined,
  MedicineBoxOutlined,
  PauseCircleFilled,
  PieChartOutlined,
  PoweroffOutlined,
  ToolOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { DateTime } from "luxon";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  changeShowLoading,
  hideLoading,
  showLoading,
} from "../../components/Spinner/Spinner";
import { ChecklistTabName } from "../../enums/checklist.enum";
import { SurgeryManagementStatus } from "../../enums/surgeryManagementStatus.enum";
import styles from "../../index.style";
import {
  patientInfoState,
  recountAlertAlarmState,
} from "../../recoil/atoms/patientInfoAtom";
import { sharedInternalInfoState } from "../../recoil/atoms/sharedInternalAtom";
import CookieService from "../../services/cookie.service";
import WrapperService from "../../services/wrapper.service";
import { Clock } from "../../types/wrapper.types";
import Spinner from "../Spinner/Spinner";
import { CheckIOType } from "../../enums/checkInOut.enum";
import { imgHandler } from "../../ImgHandler";
import sixConfig from "../../sixConfig";
import { timerAtom } from "../../recoil/atoms/timerAtom";
import logosisos from "../../assets/images/logosisos.png";
import { MedboxIcon } from "../../assets/images/medbox";
import { useSocketHook } from "../../hooks/useSocketHook";
import { userInfoState } from "../../recoil/atoms/userInfoAtom";

type MenuItem = Required<MenuProps>["items"][number];

function ParentWrapperView(payload: {
  children: any;
  title: string;
  sidebar: string;
}) {
  let navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [suspensionForm] = Form.useForm();
  const [userInfo] = useRecoilState(userInfoState);
  const [matrixVisitAnesthesisPath, setMatrixVisitAnesthesisPath] = useState<boolean>(false);
  const wrapperUserInfo = useRecoilValue(userInfoState);
  const matrixPar = wrapperUserInfo?.matrixPar;
  const isCheckInDisabled = matrixPar["system.extraTab"]
    ? !JSON.parse(matrixPar["system.extraTab"]).includes("check-in-tab")
    : true;

  const isCheckOutDisabled = matrixPar["system.extraTab"]
    ? !JSON.parse(matrixPar["system.extraTab"]).includes("check-out-tab")
    : true;

  const userFirstLastname = wrapperUserInfo?.userInfo
    ? `${wrapperUserInfo?.userInfo?.firstName || ""} ${wrapperUserInfo?.userInfo?.lastName || ""
    }`
    : "";

  const patientInfo = useRecoilValue(patientInfoState);
  const [sharedInfo, setSharedInfo] = useRecoilState(sharedInternalInfoState);
  const [displayMessage, setDisplayMessage] = useRecoilState(timerAtom);
  const [isSuspensionModalOpen, setIsSuspensionModalOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const [colorSidebar, setColorSidebar] = useState("white");
  const [roleSidebar, setRoleSidebar] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [disabledAnesthesia, setDisabledAnesthesia] = useState(false);
  const [isFinishedSurgeryModalOpen, setIsFinishedSurgeryModalOpen] = useState(false);

  const modalMode = useRef("");

  const [date, setDate] = useState({} as Clock);
  function refreshClock() {
    setDate({ currenDate: new Date() });
  }
  const customer = sixConfig.APP_CUSTOMER;
  const recountAlertAlarm = useRecoilValue(recountAlertAlarmState);

  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000);
    setSidebarColor();
    
    // Load status from localStorage on mount
    const stored = localStorage.getItem('current.status');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSharedInfo((prev) => ({
          ...prev,
          status: parsed.status || prev.status,
        }));
      } catch (error) {
        console.error('Failed to parse current.status from localStorage:', error);
      }
    }

    return function cleanup() {
      clearInterval(timerId);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    _checkIfAnesthesiaPresent();
     let matrixVisitAnesthesisPath =
      userInfo.matrixPar["system.monitor.visitAnesthesisPath"];
    setMatrixVisitAnesthesisPath(matrixVisitAnesthesisPath)
  }, [sharedInfo]);

  useEffect(() => {
    if (displayMessage.title) {
      message.info(
        t("TIMER_FINISHED") +
        " " +
        t("NAME") +
        ": " +
        displayMessage.title +
        " " +
        t("DURATION") +
        ": " +
        displayMessage.duration
      );
    }
  }, [displayMessage]);

  const isSocketDisabled = matrixPar?.["system.stopWebSocket"] === "true";

  const { isConnected: isSocketConnected, connectedUsers, disconnectSocket } = useSocketHook({
    resourceType: 'surgery-management',
    resourceUuid: sharedInfo.surgery || null,
    enabled: payload?.sidebar === 'true' && !isSocketDisabled,
    mode: 'editor'
  });

  function switchNavigation(label: React.ReactNode): void {
    const sharedInfo = JSON.parse(
      localStorage.getItem("current.surgery") || "{}"
    );

    switch (label) {
      case `${t("EQUIPE")}`:
        navigate("/equipe", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
      case `${t("MATERIAL")}`:
        navigate("/materials", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
      case `${t("IMPLANTABLE")}`:
        navigate("/implantables", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
      case `${t("FINDINGS")}`:
        navigate("/readings", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
      case `${t("INFUSIONS")}`:
        navigate("/infusions", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
      case `${t("OPERATING_PATH")}`:
        navigate("/checklist/PO", {
          state: {
            uuid: sharedInfo.surgery,
            patient: patientInfo.uuid,
            phaseName: ChecklistTabName.PO,
          },
        });
        break;
      case `${t("NURSING_RECORD")}`:
        navigate("/checklist/CI", {
          state: {
            uuid: sharedInfo.surgery,
            patient: patientInfo.uuid,
            phaseName: ChecklistTabName.CI,
          },
        });
        break;
      case `${t("CHECK_IN")}`:
        navigate("/check-in", {
          state: {
            surgeryManagementUUID: sharedInfo.surgery,
            type: CheckIOType.CHECK_IN,
          },
        });
        break;
      case `${t("CHECK_OUT")}`:
        navigate("/check-out", {
          state: {
            surgeryManagementUUID: sharedInfo.surgery,
            type: CheckIOType.CHECK_OUT,
          },
        });
        break;
      case `${t("ANESTHESIOLOGY_RECORD")}`:
        navigate("/checklist/CA", {
          state: {
            uuid: sharedInfo.surgery,
            patient: patientInfo.uuid,
            phaseName: ChecklistTabName.CA,
          },
        });
        break;
      case `${t("ANESTHESIOLOGY_PATHWAY")}`:
        navigate("/anesthesispath", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
      case `${t("ANESTHESIS_VISIT")}`:
        navigate("/anesthesisvisit", {
          state: { uuid: sharedInfo.surgery },
        });
        break;
    }
  }

  function getColor(color: string | undefined): string {
    switch (color) {
      case "yellow":
        return styles.yellow;
      case "pink":
        return styles.pink;
      case "default":
        return styles.badgeLightBlueBg;
    }

    return styles.badgeLightBlueBg;
  }

  function getBorderColor(color: string | undefined): string {
    switch (color) {
      case "yellow":
        return styles.hardYellow;
      case "pink":
        return styles.hardPink;
      case "default":
        return styles.hardBadgeLightBlueBg;
    }

    return styles.badgeLightBlueBg;
  }

  function checkDisabled(name: React.ReactNode) {
    const sharedInfo = JSON.parse(
      localStorage.getItem("current.checklists") || "{}"
    );
    switch (name) {
      case `${t("OPERATING_PATH")}`:
        return sharedInfo?.checklists?.po;
      case `${t("NURSING_RECORD")}`:
        return sharedInfo?.checklists?.ci;
      case `${t("ANESTHESIOLOGY_RECORD")}`:
        return sharedInfo?.checklists?.ca;
      case `${t("ANESTHESIOLOGY_PATHWAY")}`:
        return sharedInfo?.checklists?.pa;
    }
    return true;
  }

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    color?: string,
    children?: MenuItem[],
    hide: boolean = false
  ): MenuItem | null {
    if (hide) return null;
    return {
      key,
      children,
      label: (
        <Button
          icon={icon}
          className="w-full font-semibold text-base bg-transparent rounded-md p-4"
          type="primary"
          style={{
            backgroundColor: getColor(color),
            border: `2px solid ${getBorderColor(color)}`,
            color: styles.blueColor,
            textAlign: "left",
          }}
          onClick={() => switchNavigation(label)}
          disabled={!checkDisabled(label)}
        >
          {label}
        </Button>
      ),
      title: <span>{label}</span>,
    } as MenuItem;
  }

  const setSidebarColor = () => {
    let classMed = wrapperUserInfo.userInfo.operatorType;
    console.log(wrapperUserInfo.userInfo);
    const operatorTypes =
      matrixPar && matrixPar["system.operatorType"]
        ? JSON.parse(matrixPar["system.operatorType"])
        : {};

    if (!Object.keys(operatorTypes).length) {
      console.error(
        "Missing operatorTypes in matrixPar. I will use default color"
      );
    }

    switch (classMed) {
      case operatorTypes.medic && operatorTypes.medic.toUpperCase():
        setColorSidebar("#00CD66");
        break;
      case operatorTypes.nurse && operatorTypes.nurse.toUpperCase():
        setColorSidebar("#008080");
        break;
      case operatorTypes.anesthesis && operatorTypes.anesthesis.toUpperCase():
        setColorSidebar("#FFB5C5");
        break;
      default:
        setColorSidebar("white");
    }
    setRoleSidebar(wrapperUserInfo.userInfo.roleDescription);
  };

  const items: MenuItem[] = [
    getItem(
      `${t("EQUIPE")}`,
      "1",
      <PieChartOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "default"
    ),
    getItem(
      `${t("MATERIAL")}`,
      "2",
      <ToolOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "default"
    ),
    getItem(
      `${t("IMPLANTABLE")}`,
      "3",
      <CalculatorOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "default"
    ),
    getItem(
      `${t("FINDINGS")}`,
      "4",
      <LineChartOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "yellow"
    ),
    getItem(
      `${t("INFUSIONS")}`,
      "5",
      <MedicineBoxOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "pink"
    ),
    getItem(
      `${t("CHECK_IN")}`,
      "10",
      <MedboxIcon size="18"></MedboxIcon>,
      undefined,
      [],
      isCheckInDisabled
      // <MedicineBoxOutlined
      //   className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      // />,
      // "red"
    ),
    getItem(
      `${t("CHECK_OUT")}`,
      "11",
      <MedboxIcon size="18"></MedboxIcon>,
      "green",
      [],
      isCheckOutDisabled
    ),
    getItem(
      `${t("CHECKLIST")}`,
      "sub1",
      <UnorderedListOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "default",
      [
        getItem(
          `${t("OPERATING_PATH")}`,
          "6",
          <FieldTimeOutlined />,
          "default"
        ),
        getItem(
          `${t("NURSING_RECORD")}`,
          "7",
          <FieldTimeOutlined />,
          "default"
        ),
        getItem(
          `${t("ANESTHESIOLOGY_RECORD")}`,
          "8",
          <FieldTimeOutlined />,
          "default"
        ),
      ]
    ),
    getItem(
      `${t("ANESTHESIOLOGY_PATHWAY")}`,
      "9",
      <ClockCircleOutlined
        className={collapsed ? "ant-btn-icon align-center-icon" : undefined}
      />,
      "pink",
       matrixVisitAnesthesisPath
    ? [
        getItem(
          `${t("ANESTHESIS_VISIT")}`,
          "10",
          <ClockCircleOutlined />,
          "pink"
        ),
      ]
    : undefined
    ),
  ];

  function statusButtonLabel(): string {
    const currentStatus = sharedInfo.status;
    switch (currentStatus) {
      case SurgeryManagementStatus.ONGOING:
        return `${t("FINISH")}`;
      case SurgeryManagementStatus.CONFIRMED:
        return `${t("START")}`;
      case SurgeryManagementStatus.SUSPENDED:
        return `${t("SUSPENDED")}`;
    }
    return `${t("TERMINATED")}`;
  }

  function statusAnesthesiaLabel(): string {
    const currentStatus = sharedInfo.status;
    switch (currentStatus) {
      case SurgeryManagementStatus.ONGOING:
      case SurgeryManagementStatus.CLOSED:
        return `${t("END_ANESTHESIA")}`;
      case SurgeryManagementStatus.CONFIRMED:
        return `${t("START_ANESTHESIA")}`;
    }
    return "";
  }

  function _handleStartEndAnesthesia(type: string, check: boolean = false) {
    let payload = {
      time: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"),
      force: true
    };
    changeShowLoading(
      WrapperService.sendSurgeryTimes(sharedInfo.surgery, type, payload)
        .then((res) => {
          if (check) _checkIfAnesthesiaPresent();
          if (res?.sendHl7?.success === false) {
            console.error(res?.sendHl7?.response);
          }
        })
        .catch((error) => {
          console.log(error);
        })
    );
  }

  async function _checkAnesthesia(type: string = "") {
    showLoading();
    const result = await WrapperService.getSurgeryTimes(sharedInfo.surgery)
      .then((res) => {
        if (res?.length) {
          if (res.some((el: any) => el.type.includes(type))) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        hideLoading();
      });

    if (result != false) {
      if (type === "start_anesthesia") {
        _handleStartEndSurgery();
      } else {
        _handleStartEndAnesthesia("end-anesthesia");
      }
    } else {
      modalMode.current = type;
      setModalOpen(true);
    }
  }

  async function _checkIfAnesthesiaPresent() {
    if (!sharedInfo.surgery) return;
    const disabledAnesthesia: boolean = await WrapperService.getSurgeryTimes(
      sharedInfo.surgery
    )
      .then((res) => {
        if (res?.length) {
          if (
            res.some((el: any) =>
              el.type.includes(
                sharedInfo.status == SurgeryManagementStatus.CONFIRMED
                  ? "start_anesthesia"
                  : "end_anesthesia"
              )
            )
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.log(error);
        return false;
      });

    setDisabledAnesthesia(disabledAnesthesia);
  }

  function handleOkSurgeryTimes() {
    setModalOpen(false);
    if (modalMode.current == "start_anesthesia") {
      _handleStartEndSurgery();
    } else {
      _handleStartEndAnesthesia("end-anesthesia", true);
    }
  }

  function handleCancelSurgeryTimes() {
    setModalOpen(false);
  }

  function _handleStartEndSurgery() {
    const currentStatus = sharedInfo.status;
    switch (currentStatus) {
      case SurgeryManagementStatus.CONFIRMED:
        changeShowLoading(
          WrapperService.startSurgery(sharedInfo.surgery, patientInfo.uuid)
            .then(() => {
              setSharedInfo({
                ...sharedInfo,
                status: SurgeryManagementStatus.ONGOING,
              });
              _handleStartEndAnesthesia("start-surgery");
            })
            .catch((error) => {
              console.log(error);
            })
        );
        break;
      case SurgeryManagementStatus.ONGOING:
        changeShowLoading(
          WrapperService.endSurgery(sharedInfo.surgery, patientInfo.uuid)
            .then(() => {
              setSharedInfo({
                ...sharedInfo,
                status: SurgeryManagementStatus.CLOSED,
              });
              _handleStartEndAnesthesia("end-surgery");
            })
            .catch((error) => {
              console.log(error);
            })
        );
        break;
    }
  }
  function _handleSuspendSurgery() {
    const formItems = suspensionForm.getFieldsValue();
    changeShowLoading(
      WrapperService.suspendSurgery(sharedInfo.surgery, {
        suspensionReason: formItems.reason,
        patient: patientInfo.uuid,
      })
        .then(() => {
          setSharedInfo({
            ...sharedInfo,
            status: SurgeryManagementStatus.SUSPENDED,
          });
        })
        .catch((error) => {
          console.log(error);
        })
    );
  }

  function handleStatusChange() {
    if (sharedInfo.status === SurgeryManagementStatus.ONGOING) {
      setIsFinishedSurgeryModalOpen(true);
      return;
    }
    if (
      sharedInfo.status === SurgeryManagementStatus.CONFIRMED &&
      customer == "PUGLIASALUTE"
    ) {
      _checkAnesthesia("start_anesthesia");
    } else {
      _handleStartEndSurgery();
    }
  }

  function _handleAnesthesiaFromStatus() {
    if (SurgeryManagementStatus.CONFIRMED == sharedInfo.status) {
      _handleStartEndAnesthesia("start-anesthesia", true);
    } else if (SurgeryManagementStatus.CLOSED == sharedInfo.status) {
      _handleStartEndAnesthesia("end-anesthesia", true);
    } else {
      _checkAnesthesia("end-surgery");
    }
  }

  const showModal = () => {
    setIsSuspensionModalOpen(true);
  };

  const handleOk = () => {
    _handleSuspendSurgery();
    setIsSuspensionModalOpen(false);
  };

  const handleCancel = () => {
    setIsSuspensionModalOpen(false);
  };

  const handleCancelFinishedSurgeryModal = () => {
    setIsFinishedSurgeryModalOpen(false);
  };

  const handleOkFinishedSurgeryModal = () => {
    _handleStartEndSurgery();
    setIsFinishedSurgeryModalOpen(false);
  };

  const PatientInfo = () => {
    return (
      <>
        <div className={"p-2 bg-cyan-900"} >
          <div className="flex flex-row gap-4">
            <UserOutlined
              className="text-white bg-teal-600 rounded-md p-2"
              style={{ fontSize: "24px" }}
            />
            <div>
              <div className="font-bold w-full text-white text-lg">
                {patientInfo.firstName} {patientInfo.lastName}
              </div>
              <div className="font-bold w-full text-teal-400">
                {patientInfo.tin}
              </div>
            </div>
          </div>
        </div>
        <div className="px-2 bg-cyan-700 text-white flex flex-col justify-between">
          <div className="flex justify-between  py-2">
            <span>{t("DATE_OF_BIRTH")} </span>
            <span className="ml-2 text-sm font-semibold">
              {DateTime.fromISO(patientInfo.birthDay).toFormat("dd-MM-yyyy")}
            </span>
          </div>
          <div
            className="flex justify-between py-2"
            style={{
              borderTop: "1px solid",
              borderColor: styles.lightBlueBgColor,
            }}
          >
            <span>{t("SURGERY_DATE")} </span>
            <span className="ml-2 text-sm font-semibold">
              {DateTime.fromISO(patientInfo.surgeryDate).toFormat("dd-MM-yyyy")}
            </span>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Spinner></Spinner>
      <Modal
        open={isFinishedSurgeryModalOpen}
        onOk={handleOkFinishedSurgeryModal}
        onCancel={handleCancelFinishedSurgeryModal}
        maskClosable={false}
        closable={false}
      >
        <p>
          {t("DO_YOU_WANT_TO_TERMINATE_SURGERY")}

        </p>
      </Modal>
      <Layout
        className="layout"
        style={{
          backgroundColor: styles.greyColor,
          minHeight: "100vh",
        }}
      >
        <div className="flex h-screen w-full">
          <div className="page-layout bg-white w-full">
            <div
              className="header text-white sticky"
              style={{
                backgroundColor: styles.blueColor,
              }}
            >
              <div className="flex h-full text-2xl justify-between items-center pr-4">
                <div className="font-semibold text-white uppercase flex items-center">
                  <img
                    src={logosisos}
                    alt="sisos logo"
                    style={{
                      width: "175px",
                      marginLeft: "-8px",
                    }}
                  />
                </div>
                <div className="flex items-center font-semibold text-white justify-end">
                  <div className="p-4 text-center items-center mr-4 uppercase">
                    {CookieService.getSurgeryRoomDescription()}
                  </div>
                  <div
                    className="p-4 text-center items-center"
                    style={{ backgroundColor: styles.lightBlueBgColor }}
                  >
                    {date?.currenDate?.toLocaleString()}
                  </div>
                  <div className="ml-4 font-semibold text-xl uppercase ">
                    <UserOutlined /> {userFirstLastname}
                  </div>

                  <div className="ml-4 text-center items-center justify-between">
                    <Button
                      className="customButton"
                      type="primary"
                      size="large"
                      style={{ backgroundColor: styles.lightBlueBgColor }}
                      icon={<PoweroffOutlined />}
                      onClick={() => { disconnectSocket(); navigate("/login") }}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="role-bar bg-gray-500 block flex uppercase">
              <div
                className="w-full items-center text-center text-white font-black text-lg"
                style={{ background: colorSidebar, color: "#FFF" }}
              >
                {roleSidebar}
              </div>
            </div>
            <div className="flex">
              <div
                className="sider"
                style={{
                  backgroundColor: "#FBFBFB",
                }}
              >
                {payload?.sidebar === "true" && (
                  <Sider
                    breakpoint="lg"
                    collapsible
                    collapsed={collapsed}
                    onCollapse={(value) => setCollapsed(value)}
                    theme="light"
                    style={{
                      overflow: "hidden",
                      backgroundColor: "#FBFBFB",
                      border: "0px",
                    }}
                    width="300px"
                  >
                    <div
                      className=""
                      style={{
                        position: "sticky",
                      }}
                    >
                      {collapsed ? null : <PatientInfo />}
                    </div>

                    <Menu
                      style={{
                        width: 300,
                        padding: 0,
                        margin: 0,
                        border: 0,
                        backgroundColor: "#FBFBFB",
                        marginTop: "15px",
                      }}
                      theme="light"
                      mode="inline"
                      items={items}
                      className="custom-menu"
                    />
                  </Sider>
                )}
              </div>
              <Content className="bg-white">
                {recountAlertAlarm.status && (
                  <div className="error-banner bg-red-400 rounded-md text-white p-4 m-4 rounded-md flex items-center">
                    <div className="icon w-20" style={{ fontSize: "72px" }}>
                      <ExclamationCircleFilled></ExclamationCircleFilled>
                    </div>
                    <div className="ml-4">
                      {t("RECOUNT_ALERT_ALARM_MESSAGE")}
                      <div className="font-black">
                        {recountAlertAlarm?.recount?.title}
                      </div>
                    </div>
                  </div>
                )}

                {payload?.sidebar === "true" && (
                  <>
                    <div className="buttons page-menu-container-end">
                      <Button
                        type="primary"
                        icon={<CalendarFilled></CalendarFilled>}
                        style={{
                          backgroundColor: styles.lightBlueBgColor,
                        }}
                        onClick={() => navigate("/surgeries")}
                      >
                        {t("INTERVENTION_LIST")}
                      </Button>
                      <Button
                        className="customButton ml-4"
                        type="primary"
                        icon={<ClockCircleFilled />}
                        style={{
                          backgroundColor: styles.blueColor,
                        }}
                        onClick={() => navigate("/timers")}
                      >
                        {t("TIMER_LIST")}
                      </Button>
                      {sharedInfo.status === SurgeryManagementStatus.ONGOING ? (
                        <Button
                          type="primary"
                          icon={<PauseCircleFilled></PauseCircleFilled>}
                          style={{
                            backgroundColor: styles.red,
                          }}
                          onClick={() => showModal()}
                        >
                          {t("SUSPEND")}
                        </Button>
                      ) : null}

                      {[
                        SurgeryManagementStatus.CONFIRMED,
                        SurgeryManagementStatus.ONGOING,
                        SurgeryManagementStatus.CLOSED,
                      ].includes(
                        sharedInfo.status as SurgeryManagementStatus
                      ) && customer == "PUGLIASALUTE" ? (
                        <Button
                          type="primary"
                          icon={<CheckSquareOutlined></CheckSquareOutlined>}
                          style={{
                            backgroundColor:
                              disabledAnesthesia || recountAlertAlarm.status
                                ? styles.greyColor
                                : styles.orange,
                          }}
                          disabled={
                            disabledAnesthesia || recountAlertAlarm.status
                          }
                          onClick={() => _handleAnesthesiaFromStatus()}
                        >
                          {statusAnesthesiaLabel()}
                        </Button>
                      ) : null}

                      <Button
                        type="primary"
                        icon={<CheckCircleFilled></CheckCircleFilled>}
                        style={{
                          backgroundColor: styles.orange,
                        }}
                        disabled={recountAlertAlarm.status}
                        onClick={() => handleStatusChange()}
                      >
                        {statusButtonLabel()}
                      </Button>
                    </div>
                    <div className="flex justify-end text-center">
                      <Modal
                        title={t("CONFIGURATION_PANEL")}
                        open={isSuspensionModalOpen}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        maskClosable={false}
                        closable={false}
                      >
                        <Form
                          name="suspension_modal_form"
                          className="suspension_modal_form"
                          form={suspensionForm}
                          layout="vertical"
                        >
                          <Form.Item
                            name="reason"
                            label={t("REASON")}
                            className="form-container-item"
                            required={true}
                            rules={[
                              {
                                required: true,
                                message: `${t("REQUIRED_FIELD")}`,
                              },
                            ]}
                          >
                            <Input.TextArea />
                          </Form.Item>
                        </Form>
                      </Modal>
                    </div>
                  </>
                )}
                <Content
                  className={`Content--Layout bg-white rounded-md overflow-y-auto w-full ${payload?.sidebar === "true" ? "internal" : ""
                    }`}
                >
                  {payload.children}
                </Content>
              </Content>
              {imgHandler?.[customer]?.src_logo_right_corner && (
                <div
                  className="fixed bottom-0 right-0 mt-10 text-right text-gray-500 text-xs"
                  style={{ pointerEvents: "none" }}
                >
                  <div className="bottom-0 right-0 m-4 mt-6 text-right text-gray-500 text-xs">
                    <img
                      src={require(`../../assets/images/${imgHandler?.[customer]?.src_logo_right_corner}.jpg`)}
                      className={`${imgHandler?.[customer]?.style_logo_right_corner}`}
                      alt=""
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
      <Modal
        open={isModalOpen}
        onCancel={handleCancelSurgeryTimes}
        onOk={handleOkSurgeryTimes}
        closable={false}
        maskClosable={false}
      >
        <div className="flex flex-col items-center">
          <div className="text-2xl font-bold mb-4">{t("CONFIRM")}</div>
          <div className="text-lg mb-4">
            {t("CONFIRM_WITHOUT_ANESTHESIA_" + modalMode.current.toUpperCase())}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ParentWrapperView;
